export default __webpack_public_path__ + "7cfb80d1d634eb7ea7ea94c6eada170c.png";